import React, { ReactNode } from 'react';

// Label/value row used inside info cards.  Right-aligned value, dashed
// bottom border.  `mono` switches the value to tabular figures for currency
// and dates.

interface Props {
  label: string;
  value: ReactNode;
  mono?: boolean;
}

const KvRow = ({ label, value, mono }: Props) => (
  <div className="kv-row">
    <span className="label">{label}</span>
    <span className={`value${mono ? ' mono' : ''}`}>{value}</span>
  </div>
);

export default KvRow;
